import React from 'react';
import FileUploadField from '../../../components/Fields/FileUploadField';
import SelectListField from '../../../components/Fields/SelectListField';
import { FieldProps } from '../../../components/Fields/Types';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import WorkflowTaskReviseDocumentModel from '../../../models/WorkflowTaskReviseDocumentModel';

interface IProps {
    formData: WorkflowTaskReviseDocumentModel
    workflowId: number
    getFieldProps: (fieldName: string) => FieldProps

}
const TaskReviseDocumentView: React.FC<IProps> = ({ formData, workflowId, getFieldProps }) => {
    const attachments = useSelectListOptions(`api/v1/selectlist/WorkflowRevisableAttachments?workflowId=${workflowId}&attachmentTypeId=${formData.attachmentType.id}`, '-- Select attachment');

    return (
        <>
            <SelectListField {...getFieldProps('workflowTaskReviseDocumentModel.attachmentId')} options={attachments} />
            <FileUploadField {...getFieldProps('workflowTaskReviseDocumentModel.document')} />
        </>
    )
}
export default TaskReviseDocumentView;